<template>
  <div>
    <v-form ref="form">
      <v-row class="ma-0">
        <v-col cols="4">
          <label class="text-caption ml-1">{{ $t('Quantidade') }}</label>
          <v-text-field
            :rules="[
              (v) => (!!v && v > 0) || 'Digite a quantidade',
              (v) => v <= 35 || 'Máximo de 35 cadastros',
            ]"
            v-model="qtd"
            type="number"
            outlined
            style="max-width: 250px"
            class="primary-input"
            hide-details="auto"
          >
            <template #message="{ message }">
              {{ $t(message) }}
            </template>
          </v-text-field>
        </v-col>

        <v-col cols="4">
          <label class="text-caption ml-1">{{ $t('Categoria') }}</label>
          <v-select
            append-icon="mdi-chevron-down"
            :rules="[(v) => v != null || 'Selecione a cateogoria']"
            single-line
            menu-props="auto"
            v-model="category"
            :item-text="(item) => $t(item.text)"
            item-value="value"
            :items="categories"
            outlined
            style="max-width: 250px"
            class="primary-input"
            hide-details="auto"
          >
            <template #message="{ message }">
              {{ $t(message) }}
            </template>
          </v-select>
        </v-col>
      </v-row>

      <v-row class="ma-0" v-if="category != null">
        <v-col cols="12" class="py-0">
          <strong>Selecione os campos comuns</strong>
        </v-col>

        <v-col cols="12" sm="6" md="4">
          <v-checkbox
            v-model="selectedFields"
            hide-details="auto"
            :label="$t('Localização')"
            :value="FIELD_KEYS.LOCALIZACAO"
            v-if="category == 1"
          ></v-checkbox>
          <v-checkbox
            v-if="category == 0"
            v-model="selectedFields"
            hide-details="auto"
            :label="$t('Identificação')"
            :value="FIELD_KEYS.IDENTIFICACAO"
          ></v-checkbox>
          <v-checkbox
            v-model="selectedFields"
            hide-details="auto"
            :disabled="category == 0"
            :label="$t('Unidade')"
            :value="FIELD_KEYS.UNIDADE"
          ></v-checkbox>
          <v-checkbox
            v-model="selectedFields"
            hide-details="auto"
            :disabled="
              category == 0 || !selectedFields.includes(FIELD_KEYS.UNIDADE)
            "
            :label="$t('Setor')"
            :value="FIELD_KEYS.SETOR"
          ></v-checkbox>
          <v-checkbox
            v-model="selectedFields"
            hide-details="auto"
            :disabled="
              category == 0 || !selectedFields.includes(FIELD_KEYS.SETOR)
            "
            :label="$t('Sub-setor')"
            :value="FIELD_KEYS.SUB_SETOR"
          ></v-checkbox>
          <v-checkbox
            v-model="selectedFields"
            hide-details="auto"
            :label="$t('Nome O.S.')"
            :value="FIELD_KEYS.NOME_OS"
          ></v-checkbox>
          <v-checkbox
            v-model="selectedFields"
            hide-details="auto"
            :label="$t('Tipo O.S.')"
            :value="FIELD_KEYS.TIPO_OS"
          ></v-checkbox>
          <v-checkbox
            v-model="selectedFields"
            hide-details="auto"
            :label="$t('Responsável')"
            :value="FIELD_KEYS.RESPONSAVEL"
          ></v-checkbox>
        </v-col>

        <v-col cols="12" sm="6" md="4">
          <v-checkbox
            v-model="selectedFields"
            hide-details="auto"
            :label="$t('Solicitante')"
            :value="FIELD_KEYS.SOLICITANTE"
          ></v-checkbox>
          <v-checkbox
            v-model="selectedFields"
            hide-details="auto"
            :label="$t('Data e hora de solicitação')"
            :value="FIELD_KEYS.DATA_HORA_SOLICITACAO"
          ></v-checkbox>
          <v-checkbox
            v-model="selectedFields"
            hide-details="auto"
            :label="$t('Solicitação / Reclamação')"
            :value="FIELD_KEYS.SOLICITACAO_RECLAMACAO"
          ></v-checkbox>
          <v-checkbox
            v-if="institution.departmentTypes.includes(1)"
            v-model="selectedFields"
            hide-details="auto"
            :label="$t('Oficina')"
            :value="FIELD_KEYS.OFICINA"
          ></v-checkbox>
        </v-col>

        <v-col
          cols="12"
          md="4"
          class="d-flex align-start justify-end pt-2"
          v-if="category == 0"
        >
          <span class="text-caption text-right" style="color: red">
            *Se a categoria selecionada for equipamento, os campos Unidade,
            Setor e Sub-setor serão herdados do equipamento.
          </span>
        </v-col>
      </v-row>

      <div class="d-flex justify-end">
        <v-btn color="primary mr-0" elevation="0" @click="confirm">
          {{ $t('Continue') }}
        </v-btn>
      </div>
    </v-form>
  </div>
</template>

<script>
import { FIELD_KEYS } from './fieldKeys'

export default {
  name: 'SelectFieldsStep',

  created() {
    this.institution = JSON.parse(localStorage.getItem('institution'))
  },

  data() {
    return {
      institution: {},
      FIELD_KEYS,
      selectedFields: [],
      qtd: 0,
      category: null,
      categories: [
        { text: 'Equipamento', value: 0 },
        { text: 'Setor', value: 1 },
      ],
    }
  },

  methods: {
    confirm() {
      if (this.$refs.form.validate()) {
        const orders = []

        for (let index = 0; index < this.qtd; index++) {
          orders.push({
            category: this.category,
          })
        }

        const model = {
          orders,
          selectedFields: this.selectedFields,
          category: this.category,
        }

        this.$emit('confirm', model)
      }
    },
  },

  watch: {
    category() {
      this.selectedFields = []
    },
    selectedFields(newVal, oldVal) {
      if (this.category == 0) {
        if (newVal.includes(this.FIELD_KEYS.IDENTIFICACAO)) {
          const commonByEquipment = [
            this.FIELD_KEYS.UNIDADE,
            this.FIELD_KEYS.SETOR,
            this.FIELD_KEYS.SUB_SETOR,
          ]
          const mergedFields = [...new Set([...newVal, ...commonByEquipment])]

          if (mergedFields.length !== newVal.length) {
            this.selectedFields = mergedFields
          }
        } else {
          const filteredFields = newVal.filter(
            (field) =>
              field !== this.FIELD_KEYS.UNIDADE &&
              field !== this.FIELD_KEYS.SETOR &&
              field !== this.FIELD_KEYS.SUB_SETOR
          )

          if (filteredFields.length !== newVal.length) {
            this.selectedFields = filteredFields
          }
        }

        return
      }

      if (
        !newVal.includes(this.FIELD_KEYS.UNIDADE) &&
        (newVal.includes(this.FIELD_KEYS.SETOR) ||
          newVal.includes(this.FIELD_KEYS.SUB_SETOR))
      ) {
        this.selectedFields = newVal.filter(
          (field) =>
            field !== this.FIELD_KEYS.SETOR &&
            field !== this.FIELD_KEYS.SUB_SETOR
        )
      } else if (
        !newVal.includes(this.FIELD_KEYS.SETOR) &&
        newVal.includes(this.FIELD_KEYS.SUB_SETOR)
      ) {
        this.selectedFields = newVal.filter(
          (field) => field !== this.FIELD_KEYS.SUB_SETOR
        )
      }
    },
  },
}
</script>

<style></style>
